import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Platform,
  Modal as RNModal,
} from "react-native";
import { FontAwesome5, Ionicons } from "@expo/vector-icons";
import DateTimePicker from "@react-native-community/datetimepicker";
import { DatePickerModal } from "react-native-paper-dates";
import moment from "moment";
import Modal from "react-native-modal";
import { Row, Button, Centered } from "./all";
import { normalize } from "../utils/normalize";

const ExpirationDateSelect = (props) => {
  const [showDatepicker, setShowDatepicker] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [customDate, setCustomDate] = useState(null);
  const [showCustomPicker, setShowCustomPicker] = useState(false);

  const presetOptions = [
    { label: "30 days", days: 30 },
    { label: "60 days", days: 60 },
    { label: "90 days", days: 90 },
  ];

  useEffect(() => {
    // If value is provided (edit mode), determine which preset it matches
    if (props.value) {
      const expirationMoment = moment(props.value);
      const daysDiff = expirationMoment.diff(moment(), "days");

      const matchingPreset = presetOptions.find(
        (option) => Math.abs(daysDiff - option.days) <= 1
      );

      if (matchingPreset) {
        setSelectedOption(matchingPreset);
      } else {
        setSelectedOption({ label: "Custom", days: null });
        setCustomDate(new Date(props.value));
      }
    }
  }, [props.value]);

  const handlePresetSelect = (option) => {
    setSelectedOption(option);
    const date = moment().add(option.days, "days").toDate();
    props.onChange && props.onChange(date);
    setShowDatepicker(false);
  };

  const handleCustomSelect = () => {
    setShowDatepicker(false);
    setSelectedOption({ label: "Custom", days: null });
    setTimeout(() => {
      setShowCustomPicker(true);
    }, 1000);
  };

  const onChangeCustomDate = (event, selectedDate) => {
    if (Platform.OS === "android") {
      setShowCustomPicker(false);
    }

    if (selectedDate) {
      setCustomDate(selectedDate);
      props.onChange && props.onChange(selectedDate);

      if (Platform.OS === "ios") {
        // iOS needs explicit close
      }
    }
  };

  const onConfirmCustomDate = () => {
    setShowCustomPicker(false);
    if (customDate) {
      props.onChange && props.onChange(customDate);
    }
  };

  const getDisplayText = () => {
    if (!selectedOption) {
      return props.placeholder || "Select Expiration Date";
    }

    if (selectedOption.days === null) {
      // Custom date
      const date = customDate || props.value;
      return date ? moment(date).format("DD MMM YYYY") : "Select Date";
    }

    return `${selectedOption.label} (${moment()
      .add(selectedOption.days, "days")
      .format("DD MMM YYYY")})`;
  };

  const renderPresetOptions = () => (
    <Modal
      isVisible={showDatepicker}
      onBackdropPress={() => setShowDatepicker(false)}
      style={{ margin: 0, justifyContent: "flex-end" }}
    >
      <View
        style={{
          backgroundColor: "white",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          paddingTop: 20,
          paddingBottom: 40,
        }}
      >
        <View
          style={{
            borderBottomWidth: 1,
            borderBottomColor: "#E5E5E5",
            paddingBottom: 16,
            marginHorizontal: 24,
          }}
        >
          <Text
            style={{
              fontSize: normalize(18),
              fontWeight: "600",
              textAlign: "center",
            }}
          >
            Select Expiration Date
          </Text>
        </View>

        <View style={{ paddingHorizontal: 24, marginTop: 20 }}>
          {presetOptions.map((option, index) => (
            <TouchableOpacity
              key={index}
              onPress={() => handlePresetSelect(option)}
              style={{
                paddingVertical: 16,
                borderBottomWidth: 1,
                borderBottomColor: "#F0F0F0",
              }}
            >
              <Row style={{ justifyContent: "space-between" }}>
                <Text
                  style={{
                    fontSize: normalize(16),
                    color: "#333",
                  }}
                >
                  {option.label}
                </Text>
                <Text
                  style={{
                    fontSize: normalize(14),
                    color: "#666",
                  }}
                >
                  {moment().add(option.days, "days").format("DD MMM YYYY")}
                </Text>
              </Row>
            </TouchableOpacity>
          ))}

          <TouchableOpacity
            onPress={handleCustomSelect}
            style={{
              paddingVertical: 16,
              borderBottomWidth: 1,
              borderBottomColor: "#F0F0F0",
            }}
          >
            <Row centered>
              <Ionicons name="calendar-outline" size={20} color="#4B9BFF" />
              <Text
                style={{
                  fontSize: normalize(16),
                  color: "#4B9BFF",
                  marginLeft: 8,
                }}
              >
                Choose Custom Date
              </Text>
            </Row>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );

  const renderCustomDatePicker = () => {
    if (Platform.OS === "web") {
      return (
        <RNModal
          visible={showCustomPicker}
          transparent={true}
          animationType="fade"
          onRequestClose={() => setShowCustomPicker(false)}
        >
          <TouchableOpacity
            style={{
              flex: 1,
              backgroundColor: "rgba(0,0,0,0.5)",
              justifyContent: "center",
              alignItems: "center",
            }}
            activeOpacity={1}
            onPress={() => setShowCustomPicker(false)}
          >
            <View
              style={{
                backgroundColor: "white",
                borderRadius: 12,
                padding: 20,
                width: 320,
              }}
            >
              <DatePickerModal
                locale="en"
                mode="single"
                visible={true}
                onDismiss={() => setShowCustomPicker(false)}
                date={customDate || new Date()}
                onConfirm={(params) => {
                  setCustomDate(params.date);
                  props.onChange && props.onChange(params.date);
                  setShowCustomPicker(false);
                }}
                validRange={{
                  startDate: moment().add(1, "day").toDate(),
                  endDate: moment().add(1, "year").toDate(),
                }}
              />
            </View>
          </TouchableOpacity>
        </RNModal>
      );
    }

    if (Platform.OS === "ios") {
      return (
        <Modal
          isVisible={showCustomPicker}
          onBackdropPress={() => setShowCustomPicker(false)}
          style={{ margin: 0, justifyContent: "flex-end" }}
        >
          <View
            style={{
              backgroundColor: "white",
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              paddingBottom: 40,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 16,
                borderBottomWidth: 1,
                borderBottomColor: "#E5E5E5",
              }}
            >
              <TouchableOpacity
                onPress={() => setShowCustomPicker(false)}
                style={{ padding: 8 }}
              >
                <Text style={{ fontSize: normalize(16), color: "#333" }}>
                  Cancel
                </Text>
              </TouchableOpacity>
              <Text style={{ fontSize: normalize(16), fontWeight: "600" }}>
                Select Date
              </Text>
              <TouchableOpacity
                onPress={onConfirmCustomDate}
                style={{ padding: 8 }}
              >
                <Text style={{ fontSize: normalize(16), color: "#333" }}>
                  Done
                </Text>
              </TouchableOpacity>
            </View>
            <View style={{

              justifyContent: "center",
              alignItems: "center",
            }}>
              <DateTimePicker
                value={customDate || new Date()}
                mode="date"
                display="inline"
                onChange={onChangeCustomDate}
                minimumDate={moment().add(1, "day").toDate()}
                maximumDate={moment().add(1, "year").toDate()}
                textColor="black"
                themeVariant="light"
                style={{ backgroundColor: "white" }}
              />
            </View>
          </View>
        </Modal>
      );
    }

    // Android
    return (
      showCustomPicker && (
        <DateTimePicker
          value={customDate || new Date()}
          mode="date"
          display="default"
          onChange={onChangeCustomDate}
          minimumDate={moment().add(1, "day").toDate()}
          maximumDate={moment().add(1, "year").toDate()}
        />
      )
    );
  };

  return (
    <View style={props.style}>
      <TouchableOpacity
        onPress={() => setShowDatepicker(true)}
        style={{
          flexDirection: "row",
          alignItems: "center",
          borderWidth: 1,
          borderColor: props.error ? "red" : "#E5E5E5",
          borderRadius: 8,
          paddingHorizontal: 16,
          paddingVertical: Platform.OS === "ios" ? 16 : 14,
          backgroundColor: "white",
        }}
      >
        <FontAwesome5 name="calendar-alt" size={14} color="grey" />
        <Text
          style={{
            flex: 1,
            marginLeft: 12,
            fontSize: normalize(14),
            color: selectedOption ? "#333" : "#999",
          }}
        >
          {getDisplayText()}
        </Text>
        <Ionicons name="chevron-down" size={20} color="#666" />
      </TouchableOpacity>

      {renderPresetOptions()}
      {renderCustomDatePicker()}
    </View>
  );
};

export default ExpirationDateSelect;